<template>
    <div>
        <viemao-agreement :head="head" :body="body"></viemao-agreement>
    </div>
</template>

<script setup>
import viemaoAgreement from "@/components/agreement/viemaoAgreement.vue";

const head = {
    headSubTitle: `Updated 24 April 2025`,
    headTitle: `Usage Guidelines for Viemao's Video Downloader`,
};
const body = {
    bodyIntro: `The following guidelines outline the proper use of Viemao's Video Downloader (referred to as "the Downloader"). This Downloader facilitates the downloading of videos from platforms including, but not limited to such as TikTok, YouTube, and Twitter. Your utilization of the Downloader signifies your acceptance of these conditions:`,
    bodyInfoArr: [
        {
            type: "p",
            name: `You bear the full responsibility for securing the required permissions and rights from the proprietors of the videos you download through the Downloader. Viemao does not guarantee the usability of the downloaded videos nor does it ensure they are free from infringing any intellectual property rights.`,
        },
        {
            type: "p",
            name: `You are accountable for any infringement of copyright or other intellectual property rights resulting from your usage of the Viemao Downloader, along with the Downloader, is not liable for any harm or loss incurred due to the unauthorized use of the videos obtained via the Downloader.`,
        },
        {
            type: "p",
            name: `Viemao offers no guarantees, either stated or implied, concerning your operation of the Downloader or the content, information, materials, or products within the downloaded videos.`,
        },
        {
            type: "p",
            name: `Viemao may modify these guidelines at its discretion. Your continued use of the Downloader after such changes indicates your acceptance of the new terms.`,
        },
        {
            type: "p",
            name: `Please note that the use of Viemao Video Downloader may cause your Google account to be restricted by Google and YouTube's functionality, for which Viemao is not responsible, so please think carefully and decide whether or not to use Viemao Video Downloader.`,
        },
        {
            type: "p",
            name: `Should you disagree with these terms, you are advised against using the Downloader.`,
        },
        {
            type: "p",
            name: `Your use of the Downloader confirms your comprehension and agreement to adhere to these guidelines.`,
        },
    ],
};
</script>

<style scoped lang="scss"></style>
